module.exports = __webpack_public_path__ + "03_very_short_black.d096056c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/03_very_short_black.png
// module id = voq0
// module chunks = 0